// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/**
 * Tenant Item component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var constants = require('logic/data/Izenda.RoleSetupConstants.js');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var action = require('./Izenda.RoleItemAction');
  var DeleteIcon = require('share/components/controls/Izenda.DeleteIcon');
  var PERMISSION_KEY = require('logic/data/Izenda.AuthorizationConstants').PERMISSION_KEY;

  var RoleItem = action(function (props) {
    var store = props.store;
    var roleInfo = props.roleInfo;
    var displayName = roleInfo.name;
    var classes = classnames('u_paddingAll u_curPointer', 'truncate', { 'u-bgGray': props.roleInfo.isSelected});
    var tenantStatus = roleInfo.active ? constants.ROLE_STATE.DEACTIVATE : constants.ROLE_STATE.ACTIVATE;
    var onClick = !props.readOnly && props.onToggleActive;
    var hasEditPrivilege = props.authorization.checkPrivileges([PERMISSION_KEY.RoleSetupActionsEdit]);

    return (
      <div className={classes} onClick={props.onSelectRole} >
        <GridLayout>
          <GridLayout.Row className='izenda-RoleItem'>
            <GridLayout.Col cols={7} className="overflow-text">
              <TextHighLight
                highlight={store.roleList.filterText}
                text={displayName}
                tooltip={displayName}/>
            </GridLayout.Col>

            <GridLayout.Col cols={5} >
              <div className="pull-right">
                {
                  hasEditPrivilege && 
                  <a className={classnames('izenda-TenantStatus', { 'izenda-TenantStatus-Deactivate': roleInfo.active }) }
                    onClick={onClick}>
                    {tenantStatus}
                  </a>
                }
                <DeleteIcon keys={[props.authorizationConstants.PERMISSION_KEY.RoleSetupActionsDel]}
                  onClick={props.onDelete}
                  disabled={props.readOnly} />
              </div>
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </div>
    );
  });

  RoleItem.propTypes = {
    roleInfo: React.PropTypes.object.isRequired,
    store: React.PropTypes.object.isRequired
  };

  module.exports = connect()(RoleItem);
} ());



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/MiddlePanel/Izenda.RoleItem.jsx